import { defineComponent } from "vue";
export default defineComponent({
  name: "BaseIcon",
  props: {
    lazyLoading: {
      type: Boolean,
      "default": false
    },
    altAttribute: {
      type: String,
      "default": ""
    },
    iconName: {
      type: String,
      "default": ""
    },
    iconType: {
      type: String,
      "default": "icon-md"
    },
    iconClass: {
      type: String,
      "default": "tw-mr-5px"
    }
  },
  computed: {
    cdn: function cdn() {
      return window["_cdn"];
    }
  }
});